module.exports = {"540326100":"白玛镇","540326101":"然乌镇","540326102":"帮达镇","540326103":"同卡镇","540326200":"林卡乡","540326201":"夏里乡","540326202":"拥乡","540326203":"瓦乡","540326204":"吉达乡","540326205":"卡瓦白庆乡","540326206":"吉中乡","540326207":"益庆乡","540326208":"拉根乡","540326209":"郭庆乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/540326.json
// module id = 2515
// module chunks = 0